/**
 * Phase 3 — Story Detail Redesign.
 *
 * Central registry of the 16 predefined highlight icons. Every icon slug
 * maps to a `lucide-react` component so both the Chapter list card
 * highlight chips and the Story Detail highlight tiles / picker render
 * from the same source of truth. If you add a slug to backend records,
 * add its entry here too — unknown slugs fall back to `Star`.
 */
import {
  Umbrella, Waves, Sunset, Palmtree, Snowflake, Mountain, Camera, Star,
  Martini, UtensilsCrossed, Landmark, Building2, Footprints, Plane, Ship,
  Tent,
} from "lucide-react";

export const HIGHLIGHT_ICONS = [
  { slug: "beach",     label: "Beach umbrella", Icon: Umbrella },
  { slug: "snorkel",   label: "Snorkel",        Icon: Waves },
  { slug: "sunset",    label: "Sunset",         Icon: Sunset },
  { slug: "palm",      label: "Palm",           Icon: Palmtree },
  { slug: "ski",       label: "Ski",            Icon: Snowflake },
  { slug: "mountain",  label: "Mountain",       Icon: Mountain },
  { slug: "camera",    label: "Camera",         Icon: Camera },
  { slug: "star",      label: "Star",           Icon: Star },
  { slug: "cocktail",  label: "Cocktail",       Icon: Martini },
  { slug: "food",      label: "Food",           Icon: UtensilsCrossed },
  { slug: "temple",    label: "Temple",         Icon: Landmark },
  { slug: "city",      label: "City skyline",   Icon: Building2 },
  { slug: "hiking",    label: "Hiking",         Icon: Footprints },
  { slug: "plane",     label: "Plane",          Icon: Plane },
  { slug: "ship",      label: "Ship",           Icon: Ship },
  { slug: "tent",      label: "Tent",           Icon: Tent },
];

const _BY_SLUG = Object.fromEntries(HIGHLIGHT_ICONS.map((h) => [h.slug, h]));

export function iconForSlug(slug) {
  return (_BY_SLUG[slug] || _BY_SLUG.star).Icon;
}

/**
 * Tiny inline wrapper so JSX can render an icon by string slug without
 * pulling the whole map in every consumer.
 */
export function HighlightIconGlyph({ slug, className }) {
  const Icon = iconForSlug(slug);
  return <Icon className={className} aria-hidden="true" strokeWidth={1.6} />;
}
